import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=53c703dc&scoped=true&"
import script from "./error404.vue?vue&type=script&lang=js&"
export * from "./error404.vue?vue&type=script&lang=js&"
import style0 from "./error404.vue?vue&type=style&index=0&id=53c703dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c703dc",
  null
  
)

export default component.exports